import React, { Component } from "react";
//import OwlCarousel from "react-owl-carousel2";
// import { DropdownButton, MenuItem } from "react-bootstrap";
import "react-owl-carousel2/src/owl.carousel.css";
import "react-owl-carousel2/src/owl.theme.default.css";
import detail_play_icon from "../../manorama/assets/images/play_icon_on_hover.png";
import { isMobile } from "react-device-detect";
import { slugify } from "../../commonfiles/stringSlugify";
import account_icon from "../assets/images/account_icon.png";
import {
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  FacebookIcon,
} from "react-share";

import myplexAPI from "../api/myplexAPI";

import { isIOS } from "react-device-detect";
// import firebase from "../analytics/firebase";
import { withRouter } from "react-router";

import downloads_play_icon from "../assets/images/downloads_play_icon.png";
// import favorites_icon from "../assets/images/nav_drawer_favorites_icon.png";
// import favorites_icon_highlighted from "../assets/images/nav_drawer_favorites_icon_highlighted.png";
import like_icon_default from "../assets/images/like_icon_default.png";
import like_icon_highlighted from "../assets/images/like_icon_selected.png";
import add_to_playlist from "../assets/images/add_to_playlist.png";
import added_to_playlist_highlighted from "../assets/images/added_to_playlist.png";
import share_icon_default from "../assets/images/share_icon_default.png";
// import details_share_highlighted from "../assets/images/share_icon_selected.png";
// import details_playlist_icon_default from "../assets/images/details_playlist_icon_default.png";
// import playlist_icon_highlighted from "../assets/images/nav_drawer_playlist_icon_highlighted.png";
import lensEvents from "../LensAnalytics";
import LayoutCastandCrew from "../general/Slider/LayoutCastandCrew";
// import facebook_default from "../assets/images/facebook_default.png";

class Bcncontentinfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      buttonText: "Add",
      popUpText: "added to Watch list",
      showPopUp: false,
      is_favorite: false,
      is_playlist: false,
      current_url: window.location.href,
      showBuyNow: false,
      // flag : false
      buyNowUrl: "",
      watchtrailer: false,
      ratingValue: this.props.info.content.contentRating,
      playerButtonText: "Play Now",
      checkProp: true,
      showClass:"",
    };
    this.names = [];
  }
  componentDidMount() {
    //  console.log(this.props.info.content.categoryName.categoryType);
    // console.log(parseInt(this.state.ratingValue))
    // this.sentry();

    this.getCast();

    // console.log(window.moment())
    // if(this.props.info!==undefined && this.props.info.relatedMultimedia!==undefined&& this.props.info.relatedMultimedia.values!==undefined&&this.props.info.relatedMultimedia.values.length>0 &&this.props.info.relatedMultimedia.values[0].generalInfo._id!==undefined ){
    //   this.setState({ watchtrailer: true });

    // }

    this.checkFavorite(this.props.info._id);
    this.checkPlayList(this.props.info._id);

    if (
      this.queryStringParse(this.props.location.search).mode !== undefined &&
      this.queryStringParse(this.props.location.search).tid !== undefined
    ) {
      this.subscription(
        this.queryStringParse(this.props.location.search).mode,
        this.queryStringParse(this.props.location.search).tid
      );
    } else {
      this.subscription("", "");
    }
    // document.addEventListener("mouseup", function (e) {
    //   var container = document.getElementById("shareDropdown");
    //   // console.log(container);
    //   // console.log(container.contains(e.target));
    //   if(container!==null){

    //     if (container && !container.contains(e.target)) {
    //       container.classList.remove("share_open");
    //     } else {
      
    //         if(container.classList.contains('share_open')){
    //            container.classList.remove("share_open");
    //         }else {
    //           console.log("hi");
    //           container.classList.add("share_open");
    //         }          
         
    //     }
    //   }
      
    // });
  }
  showDropdown = () => {
    var name = this.state.showClass!==""? "" : "share_open";
    this.setState({
      showClass: name,
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.videoEndedStatus !== this.props.videoEndedStatus) {
      this.setState({
        playerButtonText: this.props.videoEndedStatus,
      });
    }

    if (prevProps.videoPause !== this.props.videoPause) {
      this.setState({
        playerButtonText: this.props.videoPause,
      });
    }
    if (prevProps.videoPlay !== this.props.videoPlay) {
      this.setState({
        playerButtonText: this.props.videoPlay,
      });
    }

    if (prevProps.info._id !== this.props.info._id) {
      this.checkFavorite(this.props.info._id);
      this.checkPlayList(this.props.info._id);
    }
    // if (prevProps.synopses_description !== this.props.synopses_description) {
    //   console.log("hi");
    //   this.setState({ flag: !this.flag });
    // }
  }
  // buyNowClick = () =>{
  //   window.loc
  // }
  // this will take to you trailer detail page
  gotoTrailer = (e) => {
    e.preventDefault();
    let urlType, urlId, urlTitle;
    urlId = this.props.info.relatedMultimedia.values[0].generalInfo._id;
    urlTitle = this.props.info.relatedMultimedia.values[0].generalInfo.title;
    if (
      this.props.info.relatedMultimedia.values[0].generalInfo.type !== undefined
    ) {
      urlType = this.props.info.relatedMultimedia.values[0].generalInfo.type;
    } else {
      urlType = "trailer";
    }
    let trailerUrl = `/${urlType}/detail/${urlId}/${urlTitle}`;
    //console.log('trailer',trailerUrl)
    localStorage.setItem("redirectUrl", trailerUrl);
    this.props.history.push(trailerUrl);
  };
  latestEpisode = () => {
    var latestEpisodeUrl = `/${this.props.episodesParams.PageName}/detail/${
      this.props.episodedata[0].generalInfo._id
    }/${slugify(this.props.episodedata[0].globalServiceName)}/${slugify(
      this.props.episodedata[0].generalInfo.title
    )}`;
    this.props.history.push(latestEpisodeUrl);
  };
  getSsoClientId = () => {
    myplexAPI.getSsoAppInfo().then((response) => {
      // console.log(response)
      if (response.data.code === 200 && response.data.status === "SUCCESS") {
        localStorage.setItem("client_id", response.data.app_id);
        // window.location.href = `https://id.manoramaonline.com/authorize?scope=openid+email+profile+offline_access+mobile&response_type=code+token+id_token&client_id=${response.data.app_id}&redirect_uri=${process.env.REACT_APP_DOMAINNAME}login&state=1135778640&nonce=212883085`;
        window.location.href = `${process.env.REACT_APP_SSO_URL}authorize?scope=openid+email+mobile+profile+offline_access&response_type=code&client_id=${process.env.REACT_APP_SSO_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_DOMAINNAME}login&state=156414&nonce=177292&display=&prompt=`
      }
    });
  };

  // registering the event buying in fire base
  firebase_buy_click = (e, buylink) => {
    if (localStorage.getItem("Logged-in")) {
      e.preventDefault();

      let contLang = this.props.info.content.language[0];
      let content_name = this.props.info.generalInfo.title;
      let new_content_name = content_name.trim().replace(/ /gi, "_");
      //console.log(new_content_name);
      let evt_name = `${new_content_name}_${contLang}_buy_clicked`;
      let info_val = `${this.props.info.generalInfo.type}_${new_content_name}_${this.props.info.generalInfo._id}`;
      //console.log(evt_name);
      // firebase.analytics().logEvent("buy_clicks", { info: info_val });
      // firebase.analytics().logEvent(evt_name, { info: info_val });
      window.location.href = buylink;
      return;
    } else {
      localStorage.setItem(
        "redirectUrl",
        this.props.location.pathname + this.props.location.search
      );

      window.location = "/login";
    }
  };

  watchClick = () => {
    if (localStorage.getItem("Logged-in")) {
    } else {
      localStorage.setItem(
        "redirectUrl",
        this.props.location.pathname + this.props.location.search
      );

      window.location = "/login";
    }
  };

  queryStringParse = (string) => {
    let parsed = {};
    if (string !== "") {
      string = string.substring(string.indexOf("?") + 1);
      let p1 = string.split("&");
      p1.map(function (value) {
        let params = value.split("=");
        return (parsed[params[0]] = params[1]);
      });
    }
    return parsed;
  };
  subscription = (mode, tid) => {
    myplexAPI
      .ybSubscription(this.props.info._id, mode, tid)
      .then((response) => {
        // console.log(response);
        // console.log('isselleable',this.props.info.generalInfo.isSellable)
        // console.log(this.props.info.generalInfo.isSellable);

        //       console.log('res',response)
        // console.log('immutable',fromJS(response.data))
        if (
          response.data.code === 200 &&
          response.data.message === "Subscription already existed"
        ) {
        } else {
          if (
            response.data.ui &&
            this.props.info.generalInfo.isSellable === true &&
            !isIOS
          ) {
            // console.log('buynow',response.data.ui.redirect)
            // if(this.queryStringParse(this.props.location.search).mode !== undefined && this.queryStringParse(this.props.location.search).tid !== undefined){

            //   this.setState({
            //     buyNowUrl: response.data.ui.redirect+'&mode='+this.queryStringParse(this.props.location.search).mode+'&tid='+this.queryStringParse(this.props.location.search).tid,
            //     showBuyNow: true
            //   })
            // }else{
            this.setState({
              buyNowUrl: response.data.ui.redirect,
              showBuyNow: true,
            });
            // }
          }
        }
      });
  };
  getYear = (date) => {
    if (!date) {
      return null;
    }
    let d = new Date(date);
    return d.getFullYear();
  };
  getGenre = (generes) => {
    return generes.map(function (genere, i) {
      return <li key={i}> {genere.name} </li>;
    });
  };
  getCast = () => {
    this.names = [];
    this.props.info.relatedCast.values.map((item, i) => {
      this.names.push(item.name);
      return null;

      // console.log(this.names)
    });
  };
  checkFavorite = (Id) => {
    //alert(Id);
    myplexAPI.getwatchlist(Id).then((response) => {
      if (response.data.code === 200 && response.data.favorite === "true") {
        this.setState({
          is_favorite: true,
          buttonText: "Added",
        });
      } else {
        this.setState({
          is_favorite: false,
          buttonText: "Add",
        });
      }
    });
  };
  //check playlist added or not  --start
  checkPlayList = (Id) => {
    //alert(Id);
    myplexAPI.getplaylist(Id).then((response) => {
      if (response.data.code === 200 && response.data.watchlist === "true") {
        this.setState({
          is_playlist: true,
        });
      } else {
        this.setState({
          is_playlist: false,
        });
      }
    });
  };

  //check playlist added or not  --end
  add_watchlist = (Id, type) => {
    // if (this.props.Auth === false) {
    //   document.getElementById("profile_img").click();
    //   return;
    // }

    myplexAPI
      .watchliststate(Id, !this.state.is_favorite, type)
      .then((response) => {
        // console.log(response, "watchlist api");
       
        if (response.data.code === 201 || response.data.code === 200) {
          lensEvents.addToFavirote(this.props.info, !this.state.is_favorite)
          //let contName=this.props.info.generalInfo.title.trim().replace(/ /gi,'_');
          if (response.data.favorite === "true") {
            // let evtVal=`added_to_watch_list_${type}_${contName}_${Id}`;
            // firebase.analytics().logEvent('add to watchlist', {'info':evtVal});
            // firebase.analytics().logEvent('add to watchlist', {
            //   'action':'added',
            //   'content name':contName,
            //   'content id':Id,
            //   'content language':this.props.info.content.language.length > 0 ?  this.props.info.content.language[0]:'',
            //   'source':'',
            //   'content genre':this.props.info.content.genre.length > 0 ?  this.props.info.genre[0].name:'',
            //   'source detail':'',
            //   'series name':''

            // });

            this._updateWatchlistState(true, "Added", "Added to Watch list");
            //   const data = window.cleverTap_data;
            //   data["content id"] = Id;
            //   data["source"] = localStorage.getItem("source");
            //   data["promo id"] = "NA";
            //   cleverTap.addedToWatchlist(data);
          } else {
            //let evtVal=`removed_from_watch_list_${type}_${contName}_${Id}`;
            // firebase.analytics().logEvent('watch_list', {'info':evtVal});

            // firebase.analytics().logEvent('add to watchlist', {
            //   'action':'removed',
            //   'content name':contName,
            //   'content id':Id,
            //   'content language':this.props.info.content.language.length > 0 ?  this.props.info.content.language[0]:'',
            //   'source':'',
            //   'content genre':this.props.info.content.genre.length > 0 ?  this.props.info.genre[0].name:'',
            //   'source detail':'',
            //   'series name':''

            // });
            this._updateWatchlistState(false, "Add", "Removed from Watch list");
          }
        } else {
          this.getSsoClientId();
        }
      });
  };

  // play list start
  add_playlist = (Id, type) => {
    // if (this.props.Auth === false) {
    //   document.getElementById("profile_img").click();
    //   return;
    // }

    myplexAPI
      .playliststate(Id, this.state.is_playlist, type)
      .then((response) => {
        // console.log(response, "watchlist api");

        if (response.data.code === 201 || response.data.code === 200) {
          // let contName=this.props.info.generalInfo.title.trim().replace(/ /gi,'_');
          if (response.data.watchlist === "true") {
            lensEvents.addToPlayList(this.props.info, true);
            // let evtVal=`added_to_watch_list_${type}_${contName}_${Id}`;
            // firebase.analytics().logEvent('add to watchlist', {'info':evtVal});
            // firebase.analytics().logEvent('add to watchlist', {
            //   'action':'added',
            //   'content name':contName,
            //   'content id':Id,
            //   'content language':this.props.info.content.language.length > 0 ?  this.props.info.content.language[0]:'',
            //   'source':'',
            //   'content genre':this.props.info.content.genre.length > 0 ?  this.props.info.genre[0].name:'',
            //   'source detail':'',
            //   'series name':''

            // });

            this._updatePlaylistState(true);
            //   const data = window.cleverTap_data;
            //   data["content id"] = Id;
            //   data["source"] = localStorage.getItem("source");
            //   data["promo id"] = "NA";
            //   cleverTap.addedToWatchlist(data);
          } else {
            //let evtVal=`removed_from_watch_list_${type}_${contName}_${Id}`;
            // firebase.analytics().logEvent('watch_list', {'info':evtVal});

            // firebase.analytics().logEvent('add to watchlist', {
            //   'action':'removed',
            //   'content name':contName,
            //   'content id':Id,
            //   'content language':this.props.info.content.language.length > 0 ?  this.props.info.content.language[0]:'',
            //   'source':'',
            //   'content genre':this.props.info.content.genre.length > 0 ?  this.props.info.genre[0].name:'',
            //   'source detail':'',
            //   'series name':''

            // });
            this._updatePlaylistState(false);
            lensEvents.addToPlayList(this.props.info, false);
          }
        } else {
          this.getSsoClientId();
        }
      });
  };

  //playlist end

  _updateWatchlistState = (is_favorite, buttonText, popUpText) => {
    this.setState(
      {
        showPopUp: true,
        is_favorite: is_favorite,
        buttonText: buttonText,
        popUpText: popUpText,
      },
      () => this.closePopUP()
    );
  };
  _updatePlaylistState = (is_playlist) => {
    this.setState({
      is_playlist: is_playlist,
    });
  };
  closePopUP = () => {
    setTimeout(() => {
      this.setState(() => ({ showPopUp: false }));
    }, 1000);
  };
  basicPopup = (url) => {
    return window.open(
      url,
      "popUpWindow",
      "height=800,width=800,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes"
    );
  };
  playContent = () => {
    var container = document.getElementById("player");
    if (container !== null) {
      var player = window.videojs(container, { controls: true });
      if (player.paused()) {
        player.play();
        if (player.paused()) {
          this.setState({
            playerButtonText: "Play Now",
          });
        } else {
          this.setState({
            playerButtonText: "Pause Now",
          });
        }
      } else {
        player.pause();
        this.setState({
          playerButtonText: "Play Now",
        });
      }
    }
  };
  shareLensEvent=(data)=>{
    lensEvents.shareEvent(data)

  }
  Dateformat(date){
    var mydate = new Date(date);
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    // var str = mydate.toString("MMMM yyyy");
    return mydate.getDate()+" "+months[mydate.getMonth()]+" "+mydate.getFullYear();
  }
  render() {
    
    //console.log(this.props.episodedata,'episode data')
    let duration = "";
    //console.log(this.props.info)
    if (
      this.props.info &&
      this.props.info.content !== undefined &&
      this.props.info.content.duration !== undefined
    ) {
      let timeArray = this.props.info.content.duration.split(":");
      if (timeArray.length > 0) {
        if (Number(timeArray[0]) === 0 && Number(timeArray[1]) === 0) {
        } else {
          duration = Number(timeArray[0]) * 60 + Number(timeArray[1]);
          duration = duration + " mins";
        }
      }
    }
    // console.log(this.getCast(this.props.info.relatedCast.values))
    // console.log(this.props.info)
    // console.log('isSellable',this.props.info.generalInfo.isSellable)
    // console.log('logged in',localStorage.getItem('Logged-in'))
    // console.log('logged in',!localStorage.getItem('Logged-in'))
    this.getCast();

    //     const options = {
    //       items: 3,
    //       nav: true,
    //       navText: ["", ""],
    //       rewind: false,
    //       margin: 10,
    //       dots: false,
    //       autoplay: false,
    //       loop: false
    //   };
    //   const events = {
    //     onDragged: function(event) {},
    //     onChanged: function(event) {}
    // };
   
    return (
      <div className="mnr_detail_page">
        <div className="movie_details">
          <div className="movies_detail_content">
            {/* <div className="movies_detail_title">
            <h1>{this.props.info.globalServiceName !== '' && <React.Fragment>{this.props.info.globalServiceName} <br /></React.Fragment>}
              {this.props.info.generalInfo.title}</h1>
          </div> */}
            {/* <p>{secureImages(ParseImgURL(
                                this.props.info.images.values,
                                "hdpi",
                                "portraitcoverposter"
                            ))}</p> */}

            {/* <div className="col-xs-3 rmv">
                        <div className="movie_details_logo">
                            <img src={secureImages(ParseImgURL(
                                this.props.info.images.values,
                                "hdpi",
                                "portraitcoverposter"
                            ))} alt="contentImage" />
                        </div>

                        
                    </div> */}
            <div className="col-xs-12 rmv">
              <div className="movie_details_text">
                <h1 className="movie_details_title">
                  {this.props.info.generalInfo.title}
                </h1>
                <div className="movie_details-div">
                  <ul>
                    {this.props.info &&
                      this.props.info.content !== undefined &&
                      this.props.info.content.duration !== undefined &&
                      this.props.info.content.genre.length > 0 && (
                        <li>
                          {this.props.info.content.genre
                            .map((val) => {
                              return val.name;
                            })
                            .join()}
                        </li>
                      )}
                    {duration !== "" && <li>{duration}</li>}
                 
                    {this.props.info.generalInfo.type==="news" && this.props.info.content.releaseDate && 
                      <li>{`${this.Dateformat(this.props.info.content.releaseDate)}`}</li> }
                  </ul>
                </div>
                {this.props.info.content.categoryType != "" && (
                  <div className="parentControl">
                    <span className="rating_category_type">
                      {this.props.info.content.categoryType}
                    </span>{" "}
                    <span className="rating_category_name">
                      {this.props.info.content.categoryName}
                    </span>
                  </div>
                )}

                {/* {this.props.episodeButton && this.props.episodedata && (
                  <div
                    className="plan_episode_btn"
                    onClick={this.latestEpisode}
                  >
                    <button className="btn watch_epi_btn">
                      <img
                        src={downloads_play_icon}
                        alt=""
                        className="downloads_play_icon"
                      />{" "}
                      <p className="epi_title">Watch Episode</p>
                      {/* this p tag commented one <p className="epi_number">{this.props.episodedata[0].title}</p> 
                    </button>
                  </div>
                )} */}
                <div className="fevitite_options mobile_favourite_options">
                  <ul>
                    {this.state.is_playlist ? (
                      <li
                        className="add_play_list social_detail social_active"
                        onClick={() =>
                          this.add_playlist(
                            this.props.info._id,
                            this.props.info.generalInfo.type
                          )
                        }
                      >
                        {/* <img src={details_playlist_icon_default} className="details_playlist_icon social_icon" />  */}
                        <img
                          src={added_to_playlist_highlighted}
                          alt=""
                          className="playlist_highlighted_icon social_icon_highlighted"
                        />
                        <p className="p_added_playlist">Added to Playlist</p>
                      </li>
                    ) : (
                      <li
                        className="add_play_list social_detail social_active"
                        onClick={() =>
                          this.add_playlist(
                            this.props.info._id,
                            this.props.info.generalInfo.type
                          )
                        }
                      >
                        <img
                          src={add_to_playlist}
                          alt=""
                          className="details_playlist_icon social_icon"
                        />
                        {/* <img src={playlist_icon_highlighted} className="playlist_highlighted_icon social_icon_highlighted" />  */}
                        <p className="padd_playlist">Add to Playlist</p>
                      </li>
                    )}
                    <li className="social_detail share_details share_details_mob">
                      <div className={"dropdown "+this.state.showClass }  id="shareDropdown" onClick={this.showDropdown}>
                        <div className="dropdown-title">
                          <img
                            src={share_icon_default}
                            alt=""
                            className="details_share_icon social_icon"
                          />
                          <p>Share</p>
                        </div>
                        <div className="dropdown-content">
                          <ul className="dropdown-list" onClick={()=>{this.shareLensEvent(this.props.info)}}>
                            <li className="dropdown-item">
                              {/* <FacebookShareButton url={window.location.href}  onClick>
                                <FacebookIcon size={25} round={true} />
                                Facebook{" "}
                              </FacebookShareButton> */}
                               <FacebookShareButton url={"https://"+window.location.host+"/share/index.php?id="+window.location.pathname.split( '/' )[3]+"&redirectURL="+window.location.href}  >
                                <FacebookIcon size={25} round={true} />
                                Facebook{" "}
                              </FacebookShareButton>
                            </li>
                            <li className="dropdown-item">
                              <TwitterShareButton url={window.location.href}>
                                <TwitterIcon size={25} round={true} />
                                Twitter
                              </TwitterShareButton>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    {this.state.is_favorite ? (
                      <li
                        className="social_detail"
                        onClick={() =>
                          this.add_watchlist(
                            this.props.info._id,
                            this.props.info.generalInfo.type
                          )
                        }
                      >
                       
                        <img
                          src={like_icon_highlighted}
                          alt=""
                          className="favorites_highlighted_icon social_icon_highlighted"
                        />
                        <p className="p_liked">Liked</p>
                      </li>
                    ) : (
                      <li
                        className="social_detail "
                        onClick={() =>
                          this.add_watchlist(
                            this.props.info._id,
                            this.props.info.generalInfo.type
                          )
                        }
                      >
                        <img
                          src={like_icon_default}
                          alt=""
                          className="details_favorites_icon social_icon"
                        />
                       
                        <p>Like</p>
                      </li>
                    )}
                    {/* <li className="share_option"></li>
                        <li className="like_option"></li> */}
                  </ul>
                </div>

                {/* <div className="desktop_fav_options">
                  {!this.props.episodeButton && (
                    <button
                      type="button"
                      className="desktop_fav_btn desktop_fav_playnow"
                      onClick={this.playContent}
                    >
                      <img src={detail_play_icon} alt="detail_play_icon" />
                      <span>{this.state.playerButtonText}</span>
                    </button>
                  )}
                  <div className="fevitite_options desktop_favourite_options desktop_playlist_section">
                    <ul>
                      {this.state.is_playlist ? (
                        <li
                          className="add_play_list social_detail social_active"
                          onClick={() =>
                            this.add_playlist(
                              this.props.info._id,
                              this.props.info.generalInfo.type
                            )
                          }
                        >
                          
                          <img
                            src={added_to_playlist_highlighted}
                            alt=""
                            className="playlist_highlighted_icon social_icon_highlighted"
                          />
                          <p className="p_added_playlist">Added to Playlist</p>
                        </li>
                      ) : (
                        <li
                          className="add_play_list social_detail social_active"
                          onClick={() =>
                            this.add_playlist(
                              this.props.info._id,
                              this.props.info.generalInfo.type
                            )
                          }
                        >
                          <img
                            src={add_to_playlist}
                            alt=""
                            className="details_playlist_icon social_icon"
                          />
                          
                          <p className="padd_playlist">Add to Playlist</p>
                        </li>
                      )}
                    </ul>
                  </div>
                </div> */}

                {/* <div className="fevitite_options desktop_favourite_options">
                  <ul>
                    {this.state.is_favorite ? (
                      <li
                        className="social_detail"
                        onClick={() =>
                          this.add_watchlist(
                            this.props.info._id,
                            this.props.info.generalInfo.type
                          )
                        }
                      >
                      
                        <img
                          src={like_icon_highlighted}
                          alt=""
                          className="favorites_highlighted_icon social_icon_highlighted"
                        />
                        <p className="p_liked">Liked</p>
                      </li>
                    ) : (
                      <li
                        className="social_detail "
                        onClick={() =>
                          this.add_watchlist(
                            this.props.info._id,
                            this.props.info.generalInfo.type
                          )
                        }
                      >
                        <img
                          src={like_icon_default}
                          alt=""
                          className="details_favorites_icon social_icon"
                        />
                      
                        <p>Like</p>
                      </li>
                    )}
                    <li className="social_detail share_details">
                      <div className="dropdown">
                        <div className="dropdown-title">
                          <img
                            src={share_icon_default}
                            alt=""
                            className="details_share_icon social_icon"
                          />
                          <p>Share</p>
                        </div>
                        <div className="dropdown-content">
                          <ul className="dropdown-list">
                            <li className="dropdown-item">
                              <FacebookShareButton url={"https://"+window.location.host+"/share/index.php?id="+window.location.pathname.split( '/' )[3]+"&redirectURL="+window.location.href} >
                                <FacebookIcon size={25} round={true} />
                                Facebook
                              </FacebookShareButton>
                            </li>
                            <li className="dropdown-item">
                              <TwitterShareButton url={window.location.href}>
                                <TwitterIcon size={25} round={true} />
                                Twitter
                              </TwitterShareButton>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div> */}

          {!isMobile && (
         <div className="synopsis_content">
            {/* <div className="movie_details_text">
                            {this.state.contentinfo.length > 0 && <h1 class="movie_details_title">{this.state.contentTitle}</h1>}
                        </div> */}
            <div className="epi_description">
                <p title={this.props.info.generalInfo.description}>{ this.props.info.generalInfo.description!=="NA" && 
                 this.props.info.generalInfo.description} 
                 
                {/* // this.props.info.generalInfo.description.substring(0, 280) } 
                // { this.props.info.generalInfo.description.length > 280 && "..."} */}
                {/* // this.props.info.generalInfo.description  */}

                </p>
                {/* <h5>More</h5> */}
            </div>

          </div>
        )}
                {isMobile && (
                  <div>
                    {this.props.info &&
                      this.props.info.generalInfo &&
                      this.props.info.generalInfo.type === "news" &&  this.props.info.content.author !=="" &&(
                        <div className="author_section">
                          <img src={account_icon} alt="account_icon" />
                          <h5>{this.props.info.content.author}</h5>
                        </div>
                      )}
                    <div className="epi_description">
                    {this.props.info  && (
                      <p>{this.props.info.generalInfo.description!=="NA" && this.props.info.generalInfo.description}</p>
                    )}
                 
                      </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {isMobile &&
          this.props.info &&
          this.props.info.relatedCast &&
          this.props.info.relatedCast.values.length > 0 &&
          this.props.info.generalInfo.type === "movie" && (
            <LayoutCastandCrew info={this.props.info}></LayoutCastandCrew>
          )}
      </div>
    );
  }
}

export default withRouter(Bcncontentinfo);
